import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class UnleashRepositoryHttp {
  constructor(private httpClient: HttpClient) {}
  isFeatureFlagEnabled(flagName: string, unleashGetFn: (id: string) => string, onTenant = false): Observable<boolean> {
    const options = onTenant
      ? {
          params: new HttpParams({ fromString: 'tenantFeature=true' }),
        }
      : {};

    const endpoint = unleashGetFn(flagName);
    return this.httpClient.get<boolean>(endpoint, options);
  }
}
